import { brandEntityId } from "./brand-entity-id";
import { brandOverlayDataHeight } from "./brand-overlay-data-height";
import { brandOverlayDataUrl } from "./brand-overlay-data-url";
import { brandOverlayDataWidth } from "./brand-overlay-data-width";
import { brandOverlayEntityId } from "./brand-overlay-entity-id";
import { brandOverlayIsDefault } from "./brand-overlay-is-default";
import { brandOverlayIsInUse } from "./brand-overlay-is-in-use";
import { brandOverlaySid } from "./brand-overlay-sid";

export const brandOverlayEntityRaw = {
  type: "object",
  required: [
    "id",
    "sid",
    "dataUrl",
    "width",
    "height",
    "isDefault",
    "isInUse",
    "brandId"
  ],
  properties: {
    id: brandOverlayEntityId,
    sid: brandOverlaySid,
    dataUrl: brandOverlayDataUrl,
    width: brandOverlayDataWidth,
    height: brandOverlayDataHeight,
    isDefault: brandOverlayIsDefault,
    isInUse: brandOverlayIsInUse,
    brandId: brandEntityId
  },
  additionalProperties: false
};
